export default "__VITE_PUBLIC_ASSET__e889ab0d__"